import React from 'react';
import { Form } from 'semantic-ui-react';

function FormInput({ 
  label = '', 
  name = '', 
  type = 'text', 
  value = '', 
  onChange = () => {}, 
  required = false,
  ...props 
}) {
  return (
    <Form.Input
      label={label}
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      required={required}
      {...props}
    />
  );
}

export default FormInput; 